import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4 0a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm13.651 10.724A7.847 7.847 0 0 0 8.536 2.11a7.85 7.85 0 0 0-5.76 11.139 7.85 7.85 0 0 0 7.945 4.399.85.85 0 0 0-.188-1.69 6.15 6.15 0 0 1-6.746-7.143 6.148 6.148 0 0 1 8.73-4.507 6.15 6.15 0 0 1 3.445 6.225.85.85 0 1 0 1.69.19m-.802 4.643a.85.85 0 0 0 .601-1.451l-2.333-2.333a.85.85 0 0 0-.601-.249h-1.982l-1.102-1.102a1.628 1.628 0 1 0-1.202 1.202l1.102 1.102v1.981c0 .226.09.442.25.601l2.333 2.333a.85.85 0 0 0 1.45-.601v-1.483zm-3.816-1.202v-1.13h1.13l.634.632h-.281a.85.85 0 0 0-.85.85v.281zm1.555-4.314a4.737 4.737 0 0 0-5.663-4.647 4.74 4.74 0 0 0 .924 9.385.85.85 0 0 0 0-1.7 3.04 3.04 0 1 1 3.039-3.038.85.85 0 0 0 1.7 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }